module.exports = __webpack_public_path__ + "static/Maison-96e6702b88434c384108f889c9293a81.jpg";